import { render, staticRenderFns } from "./registrationList.vue?vue&type=template&id=2e9c01a0&scoped=true"
import script from "./registrationList.vue?vue&type=script&lang=js"
export * from "./registrationList.vue?vue&type=script&lang=js"
import style0 from "./registrationList.vue?vue&type=style&index=0&id=2e9c01a0&lang=less&scoped=true"
import style1 from "./registrationList.vue?vue&type=style&index=1&id=2e9c01a0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9c01a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e9c01a0')) {
      api.createRecord('2e9c01a0', component.options)
    } else {
      api.reload('2e9c01a0', component.options)
    }
    module.hot.accept("./registrationList.vue?vue&type=template&id=2e9c01a0&scoped=true", function () {
      api.rerender('2e9c01a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/education/registrationList.vue"
export default component.exports